import { FC } from 'react';
import { useAssetsQueryContext } from './AssetsQueryContext';
import {
  createSelectionContext,
  SelectionContextState,
  useSelectionContext,
} from 'utils/contexts/selection';

export type AssetsSelectionContext = SelectionContextState<number>;

const [AssetsSelectionContext, useAssetsSelectionContext] = createSelectionContext<number>();

export {
  AssetsSelectionContext as SelectionContext,
  useAssetsSelectionContext as useSelectionContext,
};

export const SelectionContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { folderId, folders, assets } = useAssetsQueryContext();
  const context = useSelectionContext<number>({
    folderId,
    folders,
    contentItems: assets.map((asset) => ({ ...asset, name: asset.assetName })),
  });
  return (
    <AssetsSelectionContext.Provider value={context}>{children}</AssetsSelectionContext.Provider>
  );
};
